import { useState, useEffect } from "react";
import toast from "react-hot-toast";

import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner";
import ClubbieModal from "../../../Modal/ClubbieModal";

const MatchModal = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  mode = "create",
  initialData,
  categories = [],
}) => {
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    numMatches: 1,
  });

  useEffect(() => {
    if (isOpen) {
      setFormData({
        name: initialData?.name || "Match",
        category: initialData?.category || "",
        numMatches: 1,
      });
    }
  }, [isOpen, initialData]);

  const handleSubmit = () => {
    if (!formData.name || !formData.name.trim()) {
      toast.error("Please enter a match name");
      return;
    }
    onSubmit(formData);
  };

  const handleClose = () => {
    setFormData({ name: "", category: "", numMatches: 1 });
    onClose();
  };

  const renderFooter = () => (
    <div className="flex justify-end gap-3 w-full">
      <button
        type="button"
        className="px-6 py-3 text-sm font-medium text-app-text bg-app-card rounded-full hover:text-[#FEFCEB] transition-colors cursor-pointer"
        onClick={handleClose}
      >
        Cancel
      </button>
      <button
        type="button"
        className="bg-[#00E7FF] hover:bg-[#00cce6] text-[#021529] font-medium px-6 py-3 rounded-full text-sm transition-all cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
        onClick={handleSubmit}
        disabled={isLoading || !formData.name.trim()}
      >
        {isLoading ? (
          <>
            <LoadingSpinner size="small" />
            <span>{mode === "edit" ? "Saving..." : "Creating..."}</span>
          </>
        ) : mode === "edit" ? (
          "Save"
        ) : (
          "Create"
        )}
      </button>
    </div>
  );

  return (
    <ClubbieModal
      isOpen={isOpen}
      width="500px"
      maxHeight="90vh"
      toggle={handleClose}
      title={mode === "edit" ? "Edit match" : "Create match"}
      footer={renderFooter()}
    >
      {mode === "create" && (
        <div className="space-y-2">
          <label className="block text-[14px] font-normal text-clubbie-white ">
            Number of matches to create
          </label>
          <input
            type="number"
            className="w-full h-12 px-4 bg-app-surface border border-app-surface rounded-full text-[14px] text-[#FEFCEB] placeholder-app-text-secondary font-proxima focus:outline-none focus:border-[#00E7FF] transition-colors"
            value={formData.numMatches}
            min="1"
            max="64"
            onChange={(e) => {
              const val = e.target.value;
              if (val === "" || (parseInt(val) > 0 && /^\d+$/.test(val))) {
                setFormData((prev) => ({ ...prev, numMatches: val === "" ? "" : parseInt(val) }));
              }
            }}
            onWheel={(e) => e.target.blur()}
          />
        </div>
      )}
    </ClubbieModal>
  );
};

export default MatchModal;
